import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";

const FullBackgroundImage = dynamic(() =>
  import("@/components/Molecules/ImageCard").then((c) => c.FullBackgroundImage)
);

const Title = dynamic(() =>
  import("@/components/Atoms/Title").then((c) => c.Title)
);

const ButtonArrow = dynamic(() =>
  import("@/atoms/Buttons").then((c) => c.ButtonArrow)
);

export function ErrorHandler({ bg, copy, color }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="h-screen flex flex-col items-center justify-center">
        {copy && (
          <div className=" z-10 text-center">
            <Title color={color?.color} tag="h3" data={copy} />
            <ButtonArrow
              direction="left"
              link="/"
              className={`mt-6 justify-center`}
              color={color?.color}
            >
              {t("returnToHomePage")}
            </ButtonArrow>
          </div>
        )}
        <FullBackgroundImage data={bg} />
      </div>
    </>
  );
}
